var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSurgery(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 47,
    viewBox: "0 0 38 47",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.7146 20.0816C30.9639 15.8324 30.9639 8.943 26.7146 4.69376C22.4654 0.444515 15.576 0.444514 11.3267 4.69376C7.07751 8.943 7.07751 15.8324 11.3267 20.0816C15.576 24.3309 22.4654 24.3309 26.7146 20.0816Z",
    fill: "#F76C82"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.616 6.15674H21.4379V9.97585H25.257V14.7978H21.4379V18.6169H16.616V14.7978H12.7969V9.97585H16.616V6.15674Z",
    fill: "#F4F6F8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.0656 26.897L21.5274 29.3588L13.2952 37.591C13.2148 38.1687 13.2075 40.3464 13.1096 40.4444L8.54724 45.0067C6.46929 47.0847 2.28892 47.066 0.616266 45.8002C0.583969 45.7759 0.557276 45.745 0.538002 45.7095C0.518727 45.674 0.507322 45.6348 0.504563 45.5945C0.501804 45.5542 0.507756 45.5137 0.522013 45.4759C0.536271 45.4381 0.5585 45.4039 0.587189 45.3754L19.0656 26.897Z",
    fill: "#E4E8EB"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.0625 28.1675L32.6188 11.6111C33.7722 10.4577 35.6593 10.4577 36.8127 11.6111C37.9661 12.7645 37.9659 14.6518 36.8127 15.8051L20.2563 32.3613L16.9177 31.506L16.0625 28.1675Z",
    fill: "#66D4F1"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.1449 13.3495C34.2691 13.2295 34.4355 13.1631 34.6082 13.1646C34.7809 13.1661 34.9462 13.2354 35.0683 13.3575C35.1904 13.4796 35.2597 13.6448 35.2612 13.8175C35.2627 13.9902 35.1963 14.1566 35.0763 14.2809L28.464 20.8932C28.3397 21.0132 28.1734 21.0796 28.0006 21.0781C27.8279 21.0766 27.6627 21.0073 27.5406 20.8852C27.4185 20.763 27.3492 20.5978 27.3477 20.4251C27.3462 20.2524 27.4126 20.086 27.5326 19.9618L34.1449 13.3495Z",
    fill: "#4FC0E8"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.9108 30.9836L17.4393 34.5121C17.5277 34.6001 17.6473 34.6495 17.772 34.6495C17.8967 34.6495 18.0164 34.6001 18.1047 34.5121L20.2554 32.3614L16.0616 28.1675L13.9109 30.3182C13.8229 30.4065 13.7735 30.5261 13.7734 30.6508C13.7734 30.7756 13.8228 30.8952 13.9108 30.9836Z",
    fill: "#F4F6F8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSurgery);
export default __webpack_public_path__ + "static/media/surgery.e32ed5996e1dbde44f5a048dd5b89a8b.svg";
export { ForwardRef as ReactComponent };